import * as t from "io-ts";

const nonEmptyStringCodec = t.refinement(t.string, (value) => value.trim().length > 0, "NonEmptyString");

export default nonEmptyStringCodec;
